const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
export function formatFileSize(fileSizeInBytes, decimals = 2) {
    if (fileSizeInBytes === 0)
        return '0 B';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const i = Math.min(Math.floor(Math.log(fileSizeInBytes) / Math.log(k)), sizes.length - 1);
    return `${parseFloat((fileSizeInBytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
/**
 * Returns true when a value is not null and not undefined
 */
export function isPresent(value) {
    return value !== null && value !== undefined;
}
/**
 * Checks if the value is a number.
 * Will return false for NaN and Number objects. ex. new Number(1)
 */
export function isNumber(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
export function delay(milliseconds) {
    return new Promise((resolve) => {
        setTimeout(resolve, milliseconds);
    });
}
//# sourceMappingURL=utilityCoreFunctions.js.map